import BaseAddon from './baseAddon'
import Api from '../../../api'
var wx = require('weixin-js-sdk')
/***
 * 微信插件类
 */
export default class wxAddon extends BaseAddon {
  constructor() {
    super()
    // 绑定分享对象
    this.shareObj = {}
  }
  // 页面加载完成
  pageReady() {
    this.setInitBindShareMsg()
    if (typeof window.WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', this.wxJSBridgeReady.bind(this), false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', this.wxJSBridgeReady.bind(this))
        document.attachEvent('onWeixinJSBridgeReady', this.wxJSBridgeReady.bind(this))
      }
    } else {
      this.wxJSBridgeReady(this)
    }
  }
  /***
   * WeixinJSBridge 注入完成
   */
  wxJSBridgeReady() {
    this.JSBridgeReady()
    wx && wx.error(function (res) {
      console.error('wx error res: ', res)
    })
    wx && wx.ready(() => {
      wx.hideMenuItems({
        menuList: [
          'menuItem:copyUrl', // 复制链接
          'menuItem:originPage', // 原网页
          'menuItem:openWithQQBrowser', // 在QQ浏览器中打开
          'menuItem:openWithSafari', // 在Safari中打开
          'menuItem:share:email', //  邮件
          'menuItem:share:qq', //  QQ
          'menuItem:share:QZone' //  QZone
        ]
      })
      this.bindMenuShare()
    })
  }
  /**
   * 设置初始化对象
   */
  setInitBindShareMsg() {
    // 不同城市分享不同城市的链接
    // let cityCode = global.myStore.get(global.myStore.staticName.CITY_CODE)
    // let wxReg = 'https://' + global.tdConfig.BASE_URL + global.tdConfig.BASE_PATH + '/index.html'
    // if (typeof (cityCode) !== 'undefined' && cityCode && cityCode !== 'undefined' && cityCode !== 'null') {
    //   wxReg = 'https://' + global.tdConfig.BASE_URL + global.tdConfig.BASE_PATH + '/index.html?state=' + cityCode + "~/home/index~share"
    // }
    // let imgUrl = 'https://' + global.tdConfig.BASE_URL + global.tdConfig.BASE_PATH + '/static/imgs/share/icon_today.png'
    let domain = 'https://' + window.location.host
    this.shareObj = {
      title: '好麦客',
      desc: '好麦客公众平台会员中心',
      link: domain + '/index.html#/home/index',
      imgUrl: 'https://qianjing-public.oss-cn-shenzhen.aliyuncs.com/logo-mini.png'
    }
  }

  /***
   * 初始化分享
   */
  initBindShareMessage() {
    this.setInitBindShareMsg()
    this.bindMenuShare()
  }

  bindMenuShare() {
    // 分享对象
    let obj = this.shareObj
    if (!obj.title) {
      return false
    }

    console.log('bindMenuShare>>>>>>>>:', obj)
    try {
      // 分享给朋友
      wx.updateAppMessageShareData({
        title: obj.title, // 分享标题
        desc: obj.desc, // 分享描述
        link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: obj.imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        success: function () {
          console.log('updateAppMessageShareData >>>>>>>>:', obj)
          // 用户确认分享后执行的回调函数
          obj.success && obj.success(1)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数

        }
      })
      // 分享到朋友圈
      wx.updateTimelineShareData({
        title: (obj.titZone || obj.title), // 分享标题
        link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: obj.imgUrl, // 分享图标
        success: function () {
          console.log('updateTimelineShareData >>>>>>>>:', obj)
          // 用户确认分享后执行的回调函数
          obj.success && obj.success(2)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      })
    } catch (error) {

    }

    try {
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: obj.title, // 分享标题
        desc: obj.desc, // 分享描述
        link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: obj.imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        success: function () {
          console.log('onMenuShareAppMessage >>>>>>>>:', obj)
          // 用户确认分享后执行的回调函数
          obj.success && obj.success(1)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数

        }
      })
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: (obj.titZone || obj.title), // 分享标题
        link: obj.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: obj.imgUrl, // 分享图标
        success: function () {
          console.log('onMenuShareTimeline >>>>>>>>:', obj)
          // 用户确认分享后执行的回调函数
          obj.success && obj.success(2)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      })
    } catch (error) {

    }
  }

  JSBridgeReady() {
    // 获取url中"?"符后的字串
    let url = window.location.href
    if (url.indexOf('#') > 0) {
      url = url.substr(0, url.indexOf('#'))
    }
    Api.getSignPackage({
      url: url
    }).then(res => {
      let myData = res.data
      wx && wx.config({
        debug: false,
        appId: myData.appId,
        timestamp: myData.timestamp,
        nonceStr: myData.nonceStr,
        signature: myData.signature,
        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareWeibo',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'translateVoice',
          'startRecord',
          'stopRecord',
          'onVoiceRecordEnd',
          'playVoice',
          'onVoicePlayEnd',
          'pauseVoice',
          'stopVoice',
          'uploadVoice',
          'downloadVoice',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'downloadImage',
          'getNetworkType',
          'openLocation',
          'getLocation',
          'hideOptionMenu',
          'showOptionMenu',
          'closeWindow',
          'scanQRCode',
          'chooseWXPay',
          'getBrandWCPayRequest',
          'openProductSpecificView',
          'addCard',
          'chooseCard',
          'openCard',
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ]
      })
    }).catch((e) => {
      console.log('^^^^^^^^^^^^^^^^^^^^^^', e)
    })
  }
  /***
   * 刷新页面重新获取code
   */
  freshPageGetCode(state, clerk_code, register_store_no) {
    let url
    if (typeof (state) === 'undefined' || !state) {
      state = '/home/index'
      url = '?state=' + encodeURIComponent(state)
    } else {
      url = '?state=' + encodeURIComponent(state) + "&clerk_code=" + clerk_code + "&register_store_no=" + register_store_no
    }
    sessionStorage.clear()
    // wxb60d3d1591f16bc2   
    window.location.replace('/api/wechat/getUserInfo' + url)
  }

  // 处理参数
  handleState(state) {
    if (state && state.indexOf('~')) {
      let arr = state.split('~')
      global.myStore.set(global.myStore.staticName.LOCAL_URL, arr[0])
      return arr[0]
    } else if (state) {
      global.myStore.set(global.myStore.staticName.LOCAL_URL, state)
      return state
    } else {
      global.myStore.set(global.myStore.staticName.LOCAL_URL, '/home/index')
      return '/home/index'
    }
  }

  getUserInfoByCode(code, state, to, from, next, clerk_code, register_store_no) {
    console.log('开始请求请求getUserInfo')
    state = this.handleState(state)
    Api.getUserInfo({
      code,
      state,
      clerk_code,
      register_store_no
    }).then(res => {
      console.log('res: ', res)
      let {
        data: {
          memberInfo,
          wxInfo
        },
        status
      } = res
      global.myStore.set(global.myStore.staticName.WEIXIN_USERINFO, wxInfo)
      global.myStore.set(global.myStore.staticName.ACCESS_OPENID, wxInfo.openid)
      if (status === '200') {
        console.log(memberInfo.toString())
        if (memberInfo && memberInfo.id) { // 用户已注册
          global.myStore.set(global.myStore.staticName.USER_INFO, memberInfo)
          next(state)
        } else { // 用户未注册
          if (state == "/register/index")
            next(state)
          else
            next('/login/index')
        }
      } else {
        // 去错误页面
        next('/error')
      }
    }, err => {
      console.log(err)
      next('/error')
      // 1.获取微信的用户信息
      // 2报错，跳转到错误页面
    })
  }

  // 处理跳转
  handleRouterBeforeEach(to, from, next) {
    let openId = global.myStore.get(global.myStore.staticName.ACCESS_OPENID)
    let userInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
    // ((to.path === '/register' || to.path === '/register/index') || (to.path === '/login' || to.path === '/login/index') && openId) || (openId && userInfo && userInfo.id)
    if (to.path === '/error' ||
      ((to.path === '/register' || to.path === '/register/index') && openId) ||
      ((to.path === '/login' || to.path === '/login/index') && openId) ||
      (openId && userInfo && userInfo.id)) {
      return next()
    } else {
      let code = global.browserQuery.code
      let state = global.browserQuery.state

      if (typeof (state) !== 'undefined' && state) {
        state = decodeURIComponent(state)
      }

      if (typeof (state) !== 'undefined' && state && state.indexOf('#') > 0) {
        state = state.substr(0, state.indexOf('#'))
      }
      // let wxCode = global.myStore.get(global.myStore.staticName.WXMINI_CODE) 
      let clerk_code = global.browserQuery.clerk_code
      let register_store_no = global.browserQuery.register_store_no

      if (!code) {
        // 第一次打开
        if (state == "/register/index") {
          this.freshPageGetCode('/register/index', clerk_code, register_store_no)
        } else {
          this.freshPageGetCode()
        }
      } else {

        // 可以进行下一步了
        if (openId && typeof (openId) !== 'undefined' && openId !== 'undefined' && openId !== 'null' && (!userInfo || !userInfo.id)) {
          // 如果已经有了openId 但没有用户ID的时候
          // return next('/login/index') 
          if (state == "/register/index")
            next(to)
          // next('/register/index')
          else
            next('/login/index')

        } else {
          // if (code) {
          //   // 通过后台跳转回来，链接带有code和state
          //   global.myStore.set(global.myStore.staticName.WXMINI_CODE, code)
          // }
          // code = wxCode
          // 如果没有openId，通过code拿openId以及其他用户信息
          this.getUserInfoByCode(code, state, to, from, next, clerk_code, register_store_no)
        }
      }
    }
  }


  /**
   * 获取用户信息集 (页面打开时候获取用户信息)
   */
  getInitUserInfo(that, obj) {
    let memberInfo = global.myStore.get(global.myStore.staticName.USER_INFO)
    if (!obj.isRefresh && memberInfo && memberInfo.id && memberInfo.member_mobile && memberInfo.member_mobile !== '----') {
      // 不刷新用户信息并存在用户信息
      that.$store.dispatch('updateUserInfo', memberInfo)
      return new Promise(function (resolve) {
        resolve(memberInfo)
      })
    }
    return global.tools.getMemberInfo(that, obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools/addon/wxAddon.js